import PieChart, { PieChartProps } from "./pie-chart";

interface DoughnutChartProps extends Omit<PieChartProps, "innerRadius"> {
  thickness?: number;
}

export default function DoughnutChart({
  outerRadius = "70%",
  thickness = 40,
  ...props
}: DoughnutChartProps) {
  let innerRadius = 40; // Default numerical value

  if (typeof outerRadius === "number") {
    innerRadius = Math.max(outerRadius - thickness, 0);
  } else if (typeof outerRadius === "string" && outerRadius.endsWith("%")) {
    const outerRadiusValue = parseInt(outerRadius, 10);
    innerRadius = Math.max(outerRadiusValue - thickness, 0);
  }

  return (
    <PieChart
      innerRadius={innerRadius}
      outerRadius={outerRadius}
      paddingAngle={2}
      {...props}
    />
  );
}
